import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { remove_from_batch_loading : true, remove_from_batch: '', remove_from_batch_error: false};

export function removeFromBatch(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_REMOVE_FROM_BATCH:
        return {
            remove_from_batch_loading: true,
          remove_from_batch: '',
          remove_from_batch_error: false
        };
      case organisationConstants.RESPONSE_REMOVE_FROM_BATCH:
        return {
            remove_from_batch_loading: false,
          remove_from_batch: action.remove_from_batch,
          remove_from_batch_error: false
        };
      case organisationConstants.ERROR_REMOVE_FROM_BATCH:
        return { 
            remove_from_batch_loading: false,
            remove_from_batch: '',
            remove_from_batch_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/removeFromBatch.reducer.js